import { useTranslation } from "react-i18next";
import { TextField, Autocomplete, Box } from "@mui/material";
import FlagIcon from "examples/Icons/FlagIcon";

function LanguageSelector() {
  const { i18n, t } = useTranslation();

  const languageOptions = [
    { labelKey: "language.english", value: "en", flag: "en" },
    { labelKey: "language.armenia", value: "am", flag: "am" },
    { labelKey: "language.russian", value: "ru", flag: "ru" },
  ];

  return (
    <Autocomplete
      value={languageOptions.find((opt) => opt.value === i18n.language)}
      onChange={(_, newValue) => newValue && i18n.changeLanguage(newValue.value)}
      options={languageOptions}
      disableClearable
      getOptionLabel={(option) => t(option.labelKey)}
      renderOption={(props, option) => (
        <Box component="li" {...props} sx={{ display: "flex", alignItems: "center" }}>
          <FlagIcon country={option.flag} size="24px" />
          <Box ml={1}>{t(option.labelKey)}</Box>
        </Box>
      )}
      renderInput={(params) => <TextField {...params} placeholder={t(languageOptions.find((opt) => opt.value === i18n.language)?.labelKey || "language.english")} />}
      sx={{ width: "100" }}
    />
  );
}

export default LanguageSelector;
